import { createFileRoute } from '@tanstack/react-router';
import { adminUsersQueryOptions } from '@/app/management/users/-hooks/useAdminUsers';
import { queryClient } from '@/lib/utils/queryClient';
import { CompanyEmployeesTab } from '../../../-components/CompanyEmployeesTab';
import { DEFAULT_PAGE_SIZE } from '../../../-utils/pagination';

export const Route = createFileRoute(
  '/management/companies/(pages)/$companyId/employees/',
)({
  loader: ({ params }) =>
    queryClient
      .ensureQueryData(
        adminUsersQueryOptions({
          page: 1,
          limit: DEFAULT_PAGE_SIZE,
          filters: { companyId: [params.companyId] },
        }),
      )
      // A failed prefetch must not blank the tab — the component's own query
      // re-runs and surfaces the error inline.
      .catch(() => undefined),
  component: CompanyEmployeesPage,
});

function CompanyEmployeesPage() {
  const { companyId } = Route.useParams();
  const { isRemoved } = Route.useSearch();
  return <CompanyEmployeesTab companyId={companyId} isRemoved={isRemoved} />;
}
